export const FETCH_POPULAR_PRODUCTS_REQUEST = "FETCH_POPULAR_PRODUCTS_REQUEST";
export const FETCH_POPULAR_PRODUCTS_SUCCESS = "FETCH_POPULAR_PRODUCTS_SUCCESS";
export const FETCH_POPULAR_PRODUCTS_FAILURE = "FETCH_POPULAR_PRODUCTS_FAILURE";
